import { useQuery, useQueryClient } from "react-query";
import styled, { css } from "styled-components";

const MainWrap = styled.div`
    background:#F2F2F2;
    display: flex;
    justify-content: space-between;
    padding-top: 12px;
`;

const Pad = styled.div`
    width: 12px;
    max-width: 12px;
    background: #F2F2F2;
    border-bottom: 1px solid #929292;
`;

const Menu = styled.div`
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 34px;
    cursor: pointer;
    border-top-left-radius:${(props) => props.menuKey === 0 ? '4px' : '0px'};
    border-top-right-radius:${(props) => props.menuKey === 1 ? '4px' : '0px'};
    ${({ active }) => {
        const activeStyled = css`
            background:#ffffff;
            border: 1px solid #929292;
            border-bottom: 1px solid transparent;
        `;
        const nonActiveStyled = css`
            background:#FCFCFC;
            border-top: 1px solid #DEDEDE;
            border-left: ${(props) => props.leftLine ? '1px solid #DEDEDE' : '0px'};
            border-right: ${(props) => props.rightLine ? '0px' : '1px solid #DEDEDE'};
            border-bottom: 1px solid #929292;
            &:hover {
                background: #ffffff;
                border: 1px solid #9E9E9E;
                color: rgba(0,0,0,0.7);
                opacity: 1;
            }
        `;
        return active ? activeStyled : nonActiveStyled;
    }}
    transition: all 100ms ease-in-out;
`;

const Tab = () => {

    const { data: { tabId } } = useQuery('TAB', { initialData: {} });
    const queryClient = useQueryClient();
    

    return (
        <MainWrap>
            <Pad />
            <Menu active={!tabId || tabId !== 1}
                menuKey={0}
                leftLine={true}
                rightLine={false}
                onClick={() => queryClient.setQueryData('TAB',{tabId:0}) }
            >
                반출입
            </Menu>
            <Menu active={tabId && tabId === 1}
                menuKey={1}
                leftLine={false}
                rightLine={true}
                onClick={() => queryClient.setQueryData('TAB', { tabId: 1 })}
            >
                자산조사
            </Menu>
            <Pad />
        </MainWrap>
    )
}

export default Tab;
